module.exports = __webpack_public_path__ + "static/media/socks.37174c60.png";